import ServiceAssignmentRulesCreateComponent from './service_assignment_rules.create.component';

let ServiceAssignmentRulesCreateModule = angular.module('serviceAssignmentRulesCreate', [
  ])

  .component('serviceAssignmentRulesCreate', ServiceAssignmentRulesCreateComponent)

  .name;

export default ServiceAssignmentRulesCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/create/index.js